import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Voted from "../views/Voted.vue";
import Results from "../views/Results.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/voted",
    name: "Voted",
    component: Voted,
  },
  {
    path: "/results",
    name: "Results",
    component: Results,
  },
  {
    path: "/help",
    name: "Help",
    component: () => import(/* webpackChunkName: "help" */ "../views/Help.vue"),
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

export default router;
